import type { OpencodeToolPart } from "schemas/generated/agentTools/opencode";

import { getObjectDetail, parseRecordOrNull, quotedText } from "../shared";
import { getToolPartOutputRecord } from "./bedrock-shared";

function getRegistryTypeLabel({ type }: { type: unknown }) {
  return getObjectDetail({ properties: ["type"], value: { type } }) ?? "item";
}

export function getRegistryFindItemsDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const items = Array.isArray(outputRecord?.items) ? outputRecord.items : null;
  if (!items) {
    return null;
  }

  const typeLabel = getRegistryTypeLabel({ type: toolPart.state.input.type });
  if (items.length === 0) {
    return `for ${typeLabel}s and found none`;
  }

  return `and found ${items.length === 1 ? `1 ${typeLabel}` : `${items.length} ${typeLabel}s`}`;
}

export function getRegistryGetItemDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const outputRecord = getToolPartOutputRecord({ toolPart });
  const files = parseRecordOrNull(outputRecord?.files);
  const fileCount = files ? Object.keys(files).length : null;
  return fileCount === null
    ? null
    : `${fileCount === 1 ? "1 file" : `${fileCount} files`}`;
}

export function getRegistryCreateItemDetail({
  toolPart,
}: {
  toolPart: OpencodeToolPart;
}) {
  const created = parseRecordOrNull(
    getToolPartOutputRecord({ toolPart })?.created,
  );
  const type = getObjectDetail({ properties: ["type"], value: created });
  const slug = getObjectDetail({ properties: ["slug"], value: created });
  return type && slug ? `${type} ${quotedText({ value: slug })}` : null;
}
